import React from 'react';
import { CasePlanSection } from '@orijinworks/frontend-commons';
import { buildSectionFooterActionProps } from '../../../../utils/case-plan-section.util';
import { withEditableWidgetCallbacks } from '../../../../widgets/with-editable-widget-callbacks';
import { useEditableCasePlanSectionHook } from './useEditableCasePlanSectionHook';

/**
 * One section rendered with every editing control the staff member is allowed to use.
 * Read-only renders (preview, archived plan, Archived tab) use `CasePlanSection` directly so
 * no callback reaches it.
 */
export function EditableCasePlanSection({
  section,
  widgets: sectionWidgets = [],
  collapsed,
  onToggleCollapse,
  onAddWidget,
  onWidgetDescriptionBlur,
  onMoveWidget,
  moveUpDisabled,
  moveDownDisabled,
  titleAutoFocus = false,
  destructiveAction,
  onTitleSave,
  onDescriptionSave,
  onVisibilityChange,
  onMove,
  onRemove,
  widgetEditHandlers,
}) {
  const {
    title,
    description,
    onTitleChange,
    onTitleBlur,
    onDescriptionChange,
    onDescriptionBlur,
    onVisibleToLearnerChange,
    onMoveUp,
    onMoveDown,
    onRemove: handleRemove,
  } = useEditableCasePlanSectionHook({
    section,
    onTitleSave,
    onDescriptionSave,
    onVisibilityChange,
    onMove,
    onRemove,
  });

  const widgets = withEditableWidgetCallbacks(sectionWidgets, widgetEditHandlers);

  return (
    <CasePlanSection
      title={title}
      titleEditable
      titleAutoFocus={titleAutoFocus}
      onTitleChange={onTitleChange}
      onTitleBlur={onTitleBlur}
      description={description}
      onDescriptionChange={onDescriptionChange}
      onDescriptionBlur={onDescriptionBlur}
      visibleToLearner={section.visibleToLearner}
      onVisibleToLearnerChange={onVisibleToLearnerChange}
      widgets={widgets}
      collapsed={collapsed}
      onToggleCollapse={onToggleCollapse}
      onMoveUp={onMoveUp}
      onMoveDown={onMoveDown}
      moveUpDisabled={moveUpDisabled}
      moveDownDisabled={moveDownDisabled}
      onAddWidget={onAddWidget}
      onWidgetDescriptionBlur={onWidgetDescriptionBlur}
      onMoveWidget={onMoveWidget}
      onEmptyStateButtonClick={onAddWidget}
      {...buildSectionFooterActionProps(destructiveAction, handleRemove)}
    />
  );
}
